import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { getRequest } from '@/api/rest/hooks/requests/get';
import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import {
  GET_BUYER_PLOT_BY_ID_PATH,
  GET_PLOT_BY_ID_PATH,
  GetBuyerPlotByIdErrorDto,
  GetBuyerPlotByIdSuccessDto,
  GetPlotByIdErrorDto,
  GetPlotByIdSuccessDto,
} from '@/api/rest/resources/types/plot';
import { useMembershipType } from '@/hooks/useMembershipType';

type SuccessDto = GetPlotByIdSuccessDto | GetBuyerPlotByIdSuccessDto;
type ErrorDto = GetPlotByIdErrorDto | GetBuyerPlotByIdErrorDto;

export const usePlot = (plotIdArg?: string) => {
  const routeParams = useParams();
  const plotId = plotIdArg ?? routeParams.plotId;

  const membershipType = useMembershipType();

  const pathParams = { id: plotId };

  const queryFn = async () => {
    return getRequest<SuccessDto>(
      membershipType === MembershipWithOrganizationTypeEnum.land_steward
        ? GET_PLOT_BY_ID_PATH
        : GET_BUYER_PLOT_BY_ID_PATH,
      pathParams,
    );
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: [membershipType, 'plot', plotId],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
